const NM2KM = 1.852;
const M2FT = 3.28084;


export default class Units{
    
    static knotsToKilos(s){
        let knotSpeed = s / NM2KM;
        return Math.floor(knotSpeed);
    }
    
    static metersToFeet(alt){
        let altInFt = alt * M2FT;
        return Math.floor(altInFt);
    }

};